module.exports = __webpack_public_path__ + "src/images/jira-logo.acef416c19d354459db7a0e96fa24c80.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/jira-logo.png
// module id = 102
// module chunks = 0